export enum ProveAuthType {
  Mobile = 'mobile',
  Instant = 'instant',
  Error = 'error',
}
